import customAxios from "./axiosConfig";

const ProjectService = {
    list: function(params) {
        var api_url = window.Urls['project-list']();
        return customAxios.get(api_url, {params: params});
    },
    retrieve: function(pk, params) {
        var api_url = window.Urls['project-detail'](pk);
        return customAxios.get(api_url, {params: params});
    },
    create: function(data) {
        var api_url = window.Urls['project-list']();
        return customAxios.post(api_url, data);
    },
    update: function(pk, data) {
        var api_url = window.Urls['project-detail'](pk);
        return customAxios.put(api_url, data);
    },
    destroy: function(pk) {
        var api_url = window.Urls['project-detail'](pk);
        return customAxios.delete(api_url);
    }
}

export default ProjectService;